import { serviceCreateHealthTips, serviceGetHealthTips, serviceUpdateHealthTips } from "../services/HealthTips.service";
import EventEmitter from "../libs/Events.utils";
import store from "../store";
import constants from "../config/constants";


export const FETCH_INIT = 'FETCH_INIT_HEALTH_TIPS';
export const FETCHED = 'FETCHED_HEALTH_TIPS';
export const FETCHED_FAIL = 'FETCHED_FAIL_HEALTH_TIPS';
export const FETCHED_FILTER = 'FETCHED_FILTER_HEALTH_TIPS';
export const FETCH_NEXT = 'FETCH_NEXT_HEALTH_TIPS';
export const FILTER = 'FILTER_HEALTH_TIPS';
export const RESET_FILTER = 'RESET_FILTER_HEALTH_TIPS';
export const SET_SORTING = 'SET_SORTING_HEALTH_TIPS';
export const SET_FILTER = 'SET_FILTER_HEALTH_TIPS';
export const SET_PAGE = 'SET_PAGE_HEALTH_TIPS';
export const CHANGE_PAGE = 'CHANGE_PAGE_HEALTH_TIPS';
export const CHANGE_STATUS = 'CHANGE_STATE_HEALTH_TIPS';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_HEALTH_TIPS';

export const CREATE_DATA = 'CREATE_HEALTH_TIPS';
export const UPDATE_DATA = 'UPDATE_HEALTH_TIPS';
export const DELETE_ITEM = 'DELETE_HEALTH_TIPS';

export function actionFetchHealthTips(index = 1, sorting = {}, filter = {}, shouldReset = false) {
    const request = serviceGetHealthTips({ index, row: sorting.row, order: sorting.order, ...filter });
    return (dispatch) => {
        if (shouldReset) {
            dispatch({
                type: CHANGE_PAGE,
                payload: 1,
            });
        }
        dispatch({ type: FETCH_INIT, payload: null });
        request.then((data) => {
            dispatch({ type: SET_FILTER, payload: filter });
            dispatch({ type: SET_SORTING, payload: sorting });
            if (!data.error) {
                dispatch({ type: FETCHED, payload: { data: data?.data, page: index } });
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({ type: CHANGE_PAGE, payload: index - 1 });
                }
            } else {
                dispatch({ type: FETCHED_FAIL, payload: null });
            }
        });
    };
}

export function actionCreateHealthTips(data) {
    const request = serviceCreateHealthTips(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                EventEmitter.dispatch(EventEmitter.THROW_ERROR, { error: 'Saved', type: 'success' });
                dispatch({ type: CREATE_DATA, payload: data.data })
            } else {
                EventEmitter.dispatch(EventEmitter.THROW_ERROR, { error: data.message, type: 'error' });
            }
        })
    }
}

export function actionUpdateHealthTips(data) {
    const request = serviceUpdateHealthTips(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                EventEmitter.dispatch(EventEmitter.THROW_ERROR, { error: 'Edited Successfully', type: 'success' });
                dispatch({ type: UPDATE_DATA, payload: data.data })
            } else {
                EventEmitter.dispatch(EventEmitter.THROW_ERROR, { error: data.error, type: 'error' });
            }
        })
    }
}

export function actionDeleteHealthTips(id) {
    const request = serviceGetHealthTips({ id: id });
    return (dispatch) => {
        dispatch({ type: DELETE_ITEM, payload: id })
    }
}



export function actionChangePageHealthTips(page) {
    return (dispatch) => {
        dispatch({ type: CHANGE_PAGE, payload: page })
    }
}


export function actionFilterHealthTips(value) {
    const request = null;
    return (dispatch) => {
        dispatch({ type: FETCH_INIT, payload: null });
        request.then((data) => {
            dispatch({ type: FILTER, payload: data });
            dispatch({ type: FETCHED, payload: null });
        });
    };
}


export function actionChangeStatusHealthTips(id, status) {
    return (dispatch) => {
        dispatch({ type: CHANGE_STATUS, payload: { id, status } });
    };
}

export function actionResetFilterHealthTips() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}

export function actionSetPageHealthTips(page) {
    const stateData = store.getState().HealthTips;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data;
    const serverPage = stateData.serverPage;

    if (totalLength <= ((page + 1) * constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchHealthTips(serverPage + 1, sortingData, { query, query_data: queryData }));
    }
    return {
        type: CHANGE_PAGE,
        payload: page,
    };
}

